module.exports = __webpack_public_path__ + "img/back-to-top-button-zh-HK.b877666.png";